module.exports = __webpack_public_path__ + "static/img/Jayden-Campbell.0a74210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jayden-Campbell.jpg
// module id = M5V+
// module chunks = 0